module.exports = __webpack_public_path__ + "img/fallrecruitment2020flyer-01.e8463d7d.png";